import React from 'react'
import { Container } from 'react-bootstrap'
import Button from 'react-bootstrap/button'
import { Link, useLocation, useParams } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';
import Footer from '../Footer/Footer';

const Portfoliosweb = () => {

  const location = useLocation();

  // Verificar si la ruta actual es diferente de /Servicios
  const mostrarBoton = location.pathname !== '/Servicios';
  const mostrarSeparador = location.pathname !== '/Servicios';
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  
const {nombre} = useParams();



  return (  
  
  <>
  
  {mostrarSeparador && (
      <div className='separador'>
        <h3 className='colorini titulo-servicio'>
          <TypeAnimation
            sequence={[
              "Servicio: PORTFOLIO WEB.",500,
            ]} 
            repeat={0}
            style={{ fontSize: '1.5em' }}
          />
        </h3>
      </div>
    )}

  <Container >
    <div className='div-desarrollo' data-aos="fade-up">
      <h3  className='titulo-servicio'  style={ { color:"White",}}>DESARROLLO DE PORTFOLIO WEB</h3>{/* titulo */}
      <br></br>
      <h4 className='subtitulo-servicio' style={ { color:"White",}}>¡Destaca tu Talento con un Portafolio en Línea Profesional!</h4>{/* titulo */}
      <br></br>
      <p className="parrafo-servicio" style={ { color:"White",}}>¿Sos un artista, diseñador, fotógrafo o profesional creativo buscando mostrar tu trabajo al mundo? En NinnoTech, entendemos la importancia de tener un portafolio en línea atractivo y profesional que destaque tu talento y te ayude a destacarte en tu campo. Es por eso que ofrecemos servicios de creación de portfolios en línea personalizados para ayudarte a presentar tu trabajo de la mejor manera posible.</p>
      <br></br>
  <ul>
 
    
    <li className='listado-servicio' style={ { color:"White",}}> <h4>¿Por qué elegirnos?</h4></li>
    
    <br></br>
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Creamos portafolios en línea personalizados que reflejen tu estilo único y resalten tus habilidades y logros de manera efectiva.</li>
    <br></br>
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Nos enfocamos en crear una experiencia de usuario atractiva, para que puedan navegar fácilmente por tu portafolio y apreciar tu trabajo.</li>
    <br></br>
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Utilizamos técnicas de diseño y presentación efectivas para resaltar tus proyectos y logros de manera visualmente impactante.</li>
    
  </ul>
  <br></br>
<p className='parrafo-servicio' style={ { color:"White",}}><h5>¡Confía en NinnoTech para crear un portafolio en línea que te ayude a destacar en tu industria y atraer nuevas oportunidades profesionales! ¡Contáctanos hoy mismo para comenzar!</h5></p>


<a href='https://wa.me/2235985787' target='_blank'><Button className='btn-servicios'>Pedir Cotizacion</Button></a>
    {mostrarBoton && (
      <Link to="/Servicios">
        <Button className='btn-servicios' style={{ marginLeft: "42.5%" }} onClick={handleScrollToTop}>Volver a Servicios</Button>
      </Link>
    ) }
    </div>
    </Container>  
    {mostrarSeparador && (
      <div className='separador-f'>
      <Footer/>
      </div> 
    )}
    
    </>
  )
}

export default Portfoliosweb